import { styled } from "styled-system/jsx"

export const Textarea = styled("textarea", {
  base: {
    width: "[100%]",
    height: "[100%]",
    border: true,
    padding: "sm",
    rounded: true,
    fontSize: "14px",
    _focusWithin: {
      outline: "[2px solid]",
      outlineColor: "outline",
    },
  },
})
